module.exports = __webpack_public_path__ + "fonts/Lato-BoldItalic.7b48d663.eot";